export default __webpack_public_path__ + "static/Latex-Pillow 2-94776e4e601b7f701c021f3818a80a65.png";